// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"CustomTooltip-tooltip_7e285a4f"};